module.exports = __webpack_public_path__ + "img/eye.420561cd.svg";